(() => {
  'use strict';

  const FLAGS_ID = 'mb-variant-flags';
  const KEY_SEP = '\u0001';
  const RETRIES = [0, 60, 180, 450, 900];

  // Bottoni EasyCheckout da nascondere
  const EASY_TARGETS = [
    '#custom-button-A',
    '#custom-button-B',
    'div.shopify-app-block[id*="easycheckout_buy_button"]'
  ];

  const norm = (s) => (s ?? '').toString().replace(/\s+/g, ' ').trim();

  let byKey = null; // optionsKey -> {id,oos}

  function loadFlags() {
    if (byKey) return true;
    const el = document.getElementById(FLAGS_ID);
    if (!el) return false;

    try {
      const arr = JSON.parse(el.textContent);
      byKey = new Map();
      (arr || []).forEach(v => {
        const opts = (v.options || []).map(norm);
        byKey.set(opts.join(KEY_SEP), { id: String(v.id), oos: !!v.oos });
      });
      return true;
    } catch {
      return false;
    }
  }

  function getRoot() {
    return document.querySelector('[id*="__main-product-section"]')
      || document.querySelector('section.section-main-product')
      || document.querySelector('main')
      || document.body;
  }

  function optionIndexFromSelect(sel) {
    // id tipo "...-0", "...-1"
    const m = (sel.id || '').match(/-(\d+)$/);
    if (m) return parseInt(m[1], 10);

    // fallback: wrapper data-show-variant-position="1"
    const fs = sel.closest('[data-show-variant-position]');
    if (fs) {
      const n = parseInt(fs.getAttribute('data-show-variant-position'), 10);
      if (!Number.isNaN(n)) return n - 1;
    }
    return null;
  }

  function getSelectedOptions(root) {
    const sels = Array.from(
      root.querySelectorAll('select.select-variant-options, .select-variant-box > select, variant-selector select')
    ).map(sel => ({ sel, idx: optionIndexFromSelect(sel) }));

    sels.sort((a,b) => {
      if (a.idx == null && b.idx == null) return 0;
      if (a.idx == null) return 1;
      if (b.idx == null) return -1;
      return a.idx - b.idx;
    });

    return sels.map(x => norm(x.sel.value));
  }

  function setEasyHidden(hidden) {
    document.body.classList.toggle('mb-true-oos', hidden);
    EASY_TARGETS.forEach(selector => {
      document.querySelectorAll(selector).forEach(el => {
        if (hidden) {
          el.dataset.mbHideOos = '1';
          el.style.setProperty('display', 'none', 'important');
        } else if (el.dataset.mbHideOos === '1') {
          el.style.removeProperty('display');
          delete el.dataset.mbHideOos;
        }
      });
    });
  }

  function setVariantId(root, id) {
    // Assicura che il form /cart/add punti davvero alla variante selezionata
    const form = root.querySelector('form[action^="/cart/add"], form[action*="/cart/add"]');
    if (!form) return;

    const idEl = form.querySelector('[name="id"]');
    if (!idEl) return;

    if (String(idEl.value) !== String(id)) {
      idEl.value = String(id);
      idEl.dispatchEvent(new Event('change', { bubbles: true }));
    }
  }

  function apply() {
    if (!loadFlags()) return;

    const root = getRoot();
    const opts = getSelectedOptions(root);

    // Se non ho tutte le opzioni (vuote), non tocchiamo niente
    if (!opts.length || opts.some(v => !v)) {
      setEasyHidden(false);
      return;
    }

    const rec = byKey.get(opts.join(KEY_SEP));
    if (!rec) {
      setEasyHidden(false);
      return;
    }

    setVariantId(root, rec.id);
    setEasyHidden(!!rec.oos);
  }

  function init() {
    apply();

    document.addEventListener('change', () => {
      RETRIES.forEach(ms => setTimeout(apply, ms));
    }, true);

    // Se il tema rigenera il picker, riapplica (solo nella sezione prodotto)
    const root = getRoot();
    new MutationObserver(() => {
      requestAnimationFrame(apply);
    }).observe(root, { subtree: true, childList: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
